module.exports = __webpack_public_path__ + "images/pdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pdf.png
// module id = dp6O
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13